import React, { memo } from "react";

export default memo(function TableWrapper({ title, children }) {
  return (
    <div
      style={{
        marginBottom: 16,
      }}
    >
      <div
        style={{
          color: "rgba(0,0,0,0.85)",
          fontWeight: 500,
          fontSize: 16,
        }}
      >
        {title}
      </div>
      {children}
    </div>
  );
});
